import { ArrowUp, ArrowDown, Droplets,  PieChart, BarChart,BadgeCheckIcon } from "lucide-react";

export default function UtilitiesDashboardStats({ stats, loading }) {
    return (
        <div className="gap-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
            {/* Total Utilities Due Card */}
            <div className="bg-white shadow-lg hover:shadow-md p-6 border-blue-700 border-l-8 rounded-xl transition-all hover:-translate-y-1 duration-300">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="font-medium text-gray-600 text-sm uppercase tracking-wider">Total Amount Due</h3>
                    <div className="bg-blue-100 p-2 rounded-full">
                        <PieChart className="w-10 h-10 text-blue-600" />
                    </div>
                </div>
                {loading ? (
                    <div className="animate-pulse">
                        <div className="bg-gray-200 mb-2 rounded w-3/4 h-8"></div>
                        <div className="bg-gray-200 rounded w-1/2 h-4"></div>
                        <div className="bg-gray-200 mt-6 rounded w-full h-10"></div>
                    </div>
                ) : (
                    <>
                        <div className="mb-2 font-bold text-gray-800 text-3xl">KES {stats?.total_expenses_due?.toLocaleString('en-us')}</div>
                        <div className="flex items-center text-xs">
                            <span className={`inline-flex items-center px-2 py-1 rounded-full ${stats?.comparison?.expenses_due?.direction === 'up'
                                ? 'bg-green-100 text-green-800'
                                : 'bg-red-100 text-red-800'
                                }`}>
                                {stats?.comparison?.expenses_due?.direction === 'up' ? (
                                    <ArrowUp className="mr-1 w-3 h-3" />
                                ) : (
                                    <ArrowDown className="mr-1 w-3 h-3" />
                                )}
                                {stats?.comparison?.expenses_due?.direction === 'up' ? '+' : '-'}
                                {stats?.comparison?.expenses_due?.change_percentage}% from last month
                            </span>

                        </div>
                        {/* <button className="bg-blue-600 hover:bg-blue-700 mt-6 px-4 py-2 rounded-lg w-50 font-medium text-white text-sm transition-colors duration-200">
                            View Details
                        </button> */}
                    </>
                )}
            </div>

            {/* Water Usage Card */}
            <div className="bg-white shadow-lg hover:shadow-md p-6 border-purple-700 border-l-8 rounded-xl transition-all hover:-translate-y-1 duration-300">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="font-medium text-gray-600 text-sm uppercase tracking-wider">Water Usage</h3>
                    <div className="bg-purple-100 p-2 rounded-full">
                        <Droplets className="w-10 h-10 text-purple-600" />
                    </div>
                </div>
                {loading ? (
                    <div className="animate-pulse">
                        <div className="bg-gray-200 mb-2 rounded w-3/4 h-8"></div>
                        <div className="bg-gray-200 rounded w-1/2 h-4"></div>
                        <div className="bg-gray-200 mt-6 rounded w-full h-10"></div>
                    </div>
                ) : (
                    <>
                        <div className="mb-2 font-bold text-gray-800 text-3xl">{stats?.total_expense_variables?.toLocaleString('en-us')} liter(s)</div>
                        <div className="flex items-center text-xs">
                            <span className={`inline-flex items-center px-2 py-1 rounded-full ${stats?.comparison?.expense_variables?.direction === 'up'
                                ? 'bg-green-100 text-green-800'
                                : 'bg-red-100 text-red-800'
                                }`}>
                                {stats?.comparison?.expense_variables?.direction === 'up' ? (
                                    <ArrowUp className="mr-1 w-3 h-3" />
                                ) : (
                                    <ArrowDown className="mr-1 w-3 h-3" />
                                )}
                                {stats?.comparison?.expense_variables?.direction === 'up' ? '+' : '-'}
                                {stats?.comparison?.expense_variables?.change_percentage}% from last month
                            </span>

                        </div>
                        {/* <button className="bg-purple-600 hover:bg-purple-700 mt-6 px-4 py-2 rounded-lg w-50 font-medium text-white text-sm transition-colors duration-200">
                            View Details
                        </button> */}
                    </>
                )}
            </div>

            {/* Electricity Usage Card */}
            <div className="bg-white shadow-lg hover:shadow-md p-6 border-green-400 border-l-8 rounded-xl transition-all hover:-translate-y-1 duration-300">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="font-medium text-gray-600 text-sm uppercase tracking-wider">Total Paid Amount</h3>
                    <div className="bg-green-100 p-2 rounded-full">
                        <BadgeCheckIcon className="w-10 h-10 text-green-600" />
                    </div>
                </div>
                {loading ? (
                    <div className="animate-pulse">
                        <div className="bg-gray-200 mb-2 rounded w-3/4 h-8"></div>
                        <div className="bg-gray-200 rounded w-1/2 h-4"></div>
                        <div className="bg-gray-200 mt-6 rounded w-full h-10"></div>
                    </div>
                ) : (
                    <>
                        <div className="mb-2 font-bold text-gray-800 text-3xl">KES {stats?.total_expense_paid?.toLocaleString('en-us')}</div>
                        <div className="flex items-center text-xs">
                            <span className={`inline-flex items-center px-2 py-1 rounded-full ${stats?.comparison?.expenses_paid?.direction === 'up'
                                    ? 'bg-green-100 text-green-800'
                                    : 'bg-red-100 text-red-800'
                                }`}>
                                {stats?.comparison?.expenses_paid?.direction === 'up' ? (
                                    <ArrowUp className="mr-1 w-3 h-3" />
                                ) : (
                                    <ArrowDown className="mr-1 w-3 h-3" />
                                )}
                                {stats?.comparison?.expenses_paid?.direction === 'up' ? '+' : '-'}
                                {stats?.comparison?.expenses_paid?.change_percentage}% from last month
                            </span>
                        </div>
                        {/* <button className="bg-green-400 hover:bg-green-500 mt-6 px-4 py-2 rounded-lg w-50 font-medium text-white text-sm transition-colors duration-200">
                            View Details
                        </button> */}
                    </>
                )}
            </div>

            {/* Collection Rate Card */}
            <div className="bg-white shadow-lg hover:shadow-md p-6 border-yellow-400 border-l-8 rounded-xl transition-all hover:-translate-y-1 duration-300">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="font-medium text-gray-600 text-sm uppercase tracking-wider">Collection Rate</h3>
                    <div className="bg-yellow-100 p-2 rounded-full">
                        <BarChart className="w-10 h-10 text-yellow-600" />
                    </div>
                </div>
                {loading ? (
                    <div className="animate-pulse">
                        <div className="bg-gray-200 mb-2 rounded w-3/4 h-8"></div>
                        <div className="bg-gray-200 rounded w-1/2 h-4"></div>
                        <div className="bg-gray-200 mt-6 rounded w-full h-10"></div>
                    </div>
                ) : (
                    <>
                        <div className="mb-2 font-bold text-gray-800 text-3xl">{stats?.total_collection_rate}%</div>
                        <div className="flex items-center text-xs">
                            <span className={`inline-flex items-center px-2 py-1 rounded-full ${stats?.comparison?.collection_rate?.direction === 'up'
                                ? 'bg-green-100 text-green-800'
                                : 'bg-red-100 text-red-800'
                                }`}>
                                {stats?.comparison?.collection_rate?.direction === 'up' ? (
                                    <ArrowUp className="mr-1 w-3 h-3" />
                                ) : (
                                    <ArrowDown className="mr-1 w-3 h-3" />
                                )}
                                {stats?.comparison?.collection_rate?.direction === 'up' ? '+' : '-'}
                                {stats?.comparison?.collection_rate?.change_percentage}% from last month
                            </span>
                        </div>
                        {/* <button className="bg-yellow-400 hover:bg-yellow-500 mt-6 px-4 py-2 rounded-lg w-50 font-medium text-white text-sm transition-colors duration-200">
                            View Details
                        </button> */}
                    </>
                )}
            </div>
        </div>
    )
}